import {cache, inlineError} from '@s-ui/decorators'
import {Repository} from '@s-ui/domain'

export class HttpRatingRepository extends Repository {
  constructor({config, fetchOrFail, ratingValueObjectFactory, ratingError}) {
    super()

    this._config = config
    this._fetchOrFail = fetchOrFail
    this._ratingValueObjectFactory = ratingValueObjectFactory
    this._ratingError = ratingError
  }

  @cache({ttl: '10 minutes'})
  @inlineError
  async getNewsArticleRating(requestVO) {
    const {GENERIC} = this._config.get('COMMON').ERRORS
    const {articleId} = requestVO.toJSON()

    const endpointUrl = `${this._config.get('CONTENTFUL_API_URL')}/rating/${articleId}`

    const [responseError, response] = await this._fetchOrFail
      .withErrorsFactories({
        [GENERIC]: ({message}) => {
          return this._ratingError(message)
        }
      })
      .get(endpointUrl)

    if (responseError) return Promise.reject(responseError)

    return this._ratingValueObjectFactory(response.data)
  }
}
